import { css } from '@emotion/css';

export const activeStyles = css`
  color: var(--icon-primary);
`;
